import {
	StyledContainer,
	StyledIcon,
} from './AppConnectWiresHelpButton.styled';

interface AppConnectWiresHelpButtonProps {
	type: 'normal' | 'help' | 'error';
	onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
	onMouseUp?: (e: React.MouseEvent<HTMLDivElement>) => void;
	style?: React.CSSProperties;
	active?: boolean;
}

const AppConnectWiresHelpButton = ({
	type,
	onMouseDown,
	onMouseUp,
	style,
	active,
}: AppConnectWiresHelpButtonProps) => {
	return (
		<StyledContainer
			$type={type}
			onMouseDown={onMouseDown}
			onMouseUp={onMouseUp}
			style={style}
			$active={active}
		>
			<StyledIcon $type={type} />
		</StyledContainer>
	);
};

export { AppConnectWiresHelpButton };
